import classnames from 'classnames/bind'
import Layout from 'components/shared/Layout'
import { Title } from 'components/typo'
import React from 'react'
import ArticleCard from 'src/components/shared/ArticleCard'
import EditorsPicksCard from 'src/components/shared/EditorsPicksCard'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const EditorsPicks = ({ className, title, posts = [], card }) => {
  return (
    <div className={cx(className, css.EditorsPicks)}>
      <Layout type="maxWidth">
        <Layout type="wrapper">
          <Title className={css.title}>{title}</Title>
          <div className={css.wrapper}>
            <ul className={css.posts}>
              {posts.map((post, i) => {
                return (
                  <ArticleCard
                    key={`post-${post.title}-${i}`}
                    className={css.cardContainer}
                    tiny
                    {...post}
                  />
                )
              })}
            </ul>
            <EditorsPicksCard className={css.card} {...card} />
          </div>
        </Layout>
      </Layout>
    </div>
  )
}

export default EditorsPicks
